import {iomoLuminaires as luminaires} from '../luminaires/iomoLuminaires';
import {IomoLayout} from './iomoLayout';

class IomoClusterLayout extends IomoLayout {

	calculate(design, configValues) {
		let amount = configValues.numberOfHeads;
		const branches = [];

		const {maxNumberOfHeads, height} = this.calculateLimits(design, configValues);

		amount = Math.min(amount, maxNumberOfHeads);

		for (let i = 0; i < amount; i++) {
			branches.push({
				angle: (360 / amount) * i,
				height: height,
				pitch: configValues.pitch,
				roll: configValues.roll,
			});
		}

		return {
			maxNumberOfHeads: maxNumberOfHeads,
			branches: branches
		};
	}
	calculateLimits(design, configValues) {
		const DesignClass = luminaires[design];
		const entry = DesignClass.poleSizes[DesignClass.getPoleId(configValues)];
		const height = Math.min(entry.maxHeight, Math.max(configValues.heightMax));
		const newH = entry.height - height;
		const newDiameter = entry.ratio * newH * 2 + entry.topDiameter;
		let maxNumberOfHeads = 5;
		const bracketId = +DesignClass.getBracketId(configValues, 0);
		if (bracketId === 3) {
			maxNumberOfHeads = 4;
			if (newDiameter < 0.160) {
				maxNumberOfHeads = 4;
			}
		} else {
			if (newDiameter < 0.150) {
				maxNumberOfHeads = 5;
				if (newDiameter < 0.128) {
					maxNumberOfHeads = 5;
				}
			}
		}
		return {
			height: height,
			heightMax: height,
			maxNumberOfHeads: maxNumberOfHeads
		};
	}
}

export {IomoClusterLayout};
